import { ModalCertificadoGerarConfirmarComponent } from './components/modal-certificado-gerar-confirmar/modal-certificado-gerar-confirmar.component';
import { CertificadoService } from './services/certificado.service';
import { ModalCertificadoGerarComponent } from './components/modal-certificado-gerar/modal-certificado-gerar.component';
import { BrowserModule } from '@angular/platform-browser';
import {APP_INITIALIZER, NgModule} from '@angular/core';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { HomeComponent } from './components/home/home.component';
import { DetalheComponent } from './components/detalhe/detalhe.component';
import { PermissoesComponent } from './components/permissoes/permissoes.component';
import { SolicitacoesComponent } from './components/solicitacoes/solicitacoes.component';
import { BarraGovernoComponent } from './components/barra-governo/barra-governo.component';
import { BarraGovernoService } from './services/barra-governo.service';
import { CabecalhoComponent } from './components/cabecalho/cabecalho.component';
import { CabecalhoService } from './services/cabecalho.service';
import { PageService } from './services/page.service';
import { RodapeService } from './services/rodape.service';
import { RodapeComponent } from './components/rodape/rodape.component';
import { SistemasService } from './services/sistemas.service';
import { FilterPipe } from './pipes/filter/filter';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GerenciarCredenciaisComponent } from './components/gerenciar-credenciais/gerenciar-credenciais.component';
import { InfoUsuarioComponent } from './components/info-usuario/info-usuario.component';
import { AlertConfirmacaoComponent } from './components/alert-confirmacao/alert-confirmacao.component';
import { AuthService } from './services/auth.service';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { StorageService } from './services/storage.service';
import { LoadingPageComponent } from './components/loading-page/loading-page.component';
import { SolicitacoesService } from './services/solicitacoes.service';
import { CredenciaisService } from './services/credenciais.service';
import { ModalSolicitarAcessoProducaoComponent } from './components/modal-solicitar-acesso-producao/modal-solicitar-acesso-producao.component';
import { ModalCadastroCredencialComponent } from './components/modal-cadastro-credencial/modal-cadastro-credencial.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { NgxSpinnerModule } from 'ngx-spinner';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { DetalhePdfComponent } from './components/detalhe-pdf/detalhe-pdf.component';
import { LightboxModule } from 'ngx-lightbox';
import { AnexosComponent } from './components/anexos/anexos.component';
import { AnexosService } from './services/anexos.service';
import { LoginComponent } from './components/login/login.component';
import { HttpInterceptorToken } from './interceptors/http-interceptor-token';
import { AutenticadoGuard } from './guards/autenticado.guard';
import { SolicitacaoDeAcessoComponent } from './components/solicitacao-de-acesso/solicitacao-de-acesso.component';
import { ModalCertificadoCerComponent } from './components/modal-certificado-cer/modal-certificado-cer.component';
import { ModalCertificadoPfxComponent } from './components/modal-certificado-pfx/modal-certificado-pfx.component';
import { ConsultaService } from './services/consulta.service';
import { ModalAdicionarEstabelecimentoFilhoComponent } from './components/modal-adicionar-estabelecimento-filho/modal-adicionar-estabelecimento-filho.component';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { ModalAdicionarSistemaComponent } from './components/modal-adicionar-sistema/modal-adicionar-sistema.component';
import { ModalAdicionarPeriodoComponent, DefaultIntl } from './components/modal-adicionar-periodo/modal-adicionar-periodo.component';
import { ModalAdicionarItemPortfolioComponent } from './components/modal-adicionar-item-portfolio/modal-adicionar-item-portfolio.component';
import { TermosDeUsoComponent } from './components/termos-de-uso/termos-de-uso.component';
import { ResumoSolicitacaoComponent } from './components/resumo-solicitacao/resumo-solicitacao.component';
import { TermoCnsComponent } from './components/termo/cns/termo-cns.component';
import { TermoPniComponent } from './components/termo/pni/termo-pni.component';
import { TermoRndsComponent } from './components/termo/rnds/termo-rnds.component';
import { BrMaskerModule } from 'br-mask';
import ptBr from '@angular/common/locales/pt';
import { registerLocaleData } from '@angular/common';
import { ModalSucessoComponent } from './components/modal-sucesso/modal-sucesso.component';

import { OwlDateTimeModule, OwlNativeDateTimeModule, OwlDateTimeIntl } from 'ng-pick-datetime';

import { OWL_DATE_TIME_LOCALE } from 'ng-pick-datetime';
import { ApiService } from './services/api.service';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { TermoBnafarComponent } from './components/termo/bnafar/termo-bnafar.component';
import { TermoEsusComponent } from './components/termo/esus/termo-esus.component';
import { ModalCertificadoRevogarComponent } from './components/modal-certificado-revogar/modal-certificado-revogar.component';
import { ModalAdicionarAlertaComponent } from './components/modal-adicionar-alerta/modal-adicionar-alerta.component';
import { ModalDetailComponent } from './components/modal-detail/modal-detail.component';
import { ModalAlertaAvisoComponent } from './components/modal-alerta-aviso/modal-alerta-aviso.component';
import { ModalTermoComponent } from './components/modal-termo/modal-termo.component';
import { ModalRequestComponent } from './components/modal-request/modal-request.component';
import { DownloadCsvComponent } from './components/download-csv/download-csv.component';
import { FederalizacaoComponent } from './components/federalizacao/federalizacao.component';
import { CpfLiberadoCsvComponent } from './components/cpf-liberado-csv/cpf-liberado-csv.component';
import { ArquivoCsvComponent } from './components/arquivo-csv/arquivo-csv.component';
import { ModalAddDownloadCsvComponent } from './components/modal-add-download-csv/modal-add-download-csv.component';
import { ModalAddPermissaoCsvComponent } from './components/modal-add-permissao-csv/modal-add-permissao-csv.component';
import { PermissoesService } from './services/permissoes.service';
import { ModalArquivosLogsComponent } from './components/modal-arquivos-logs/modal-arquivos-logs.component';
import { ImunizacaoService } from './services/imunizacao.service';
import { ModalValidaCsvComponent } from './components/modal-valida-csv/modal-valida-csv.component';
import { FileDropModule } from 'ngx-file-drop';
import { FederalizacaoService } from './services/federalizacao.service';
import { ModalIpsComponent } from './components/modal-ips/modal-ips.component';
import {HomeRedirectGuard} from './guards/home-redirect.guard';
import {AppInitService} from './services/app-init.service';

export function initializeApp(appInitService: AppInitService) {
  return () => appInitService.init();
}

registerLocaleData(ptBr);

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    DetalheComponent,
    PermissoesComponent,
    SolicitacoesComponent,
    SolicitacaoDeAcessoComponent,
    GerenciarCredenciaisComponent,
    DownloadCsvComponent,
    FederalizacaoComponent,
    CpfLiberadoCsvComponent,
    ArquivoCsvComponent,
    BarraGovernoComponent,
    CabecalhoComponent,
    RodapeComponent,
    FilterPipe,
    InfoUsuarioComponent,
    AlertConfirmacaoComponent,
    DetalhePdfComponent,
    AnexosComponent,
    LoadingPageComponent,
    ModalSolicitarAcessoProducaoComponent,
    ModalCadastroCredencialComponent,
    ModalAdicionarEstabelecimentoFilhoComponent,
    ModalAdicionarSistemaComponent,
    ModalAdicionarPeriodoComponent,
    ModalAdicionarItemPortfolioComponent,
    ModalCertificadoCerComponent,
    ModalCertificadoPfxComponent,
    ModalCertificadoGerarComponent,
    ModalCertificadoGerarConfirmarComponent,
    ModalCertificadoRevogarComponent,
    ModalSucessoComponent,
    ModalTermoComponent,
    ModalAdicionarAlertaComponent,
    ModalDetailComponent,
    ModalAddDownloadCsvComponent,
    ModalValidaCsvComponent,
    ModalAddPermissaoCsvComponent,
    LoginComponent,
    TermosDeUsoComponent,
    ResumoSolicitacaoComponent,
    TermoCnsComponent,
    TermoPniComponent,
    TermoRndsComponent,
    TermoBnafarComponent,
    TermoEsusComponent,
    ModalAlertaAvisoComponent,
    ModalRequestComponent,
    ModalArquivosLogsComponent,
    ModalIpsComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    NgxSpinnerModule,
    PdfViewerModule,
    LightboxModule,
    ToastrModule.forRoot(),
    BrMaskerModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    FileDropModule,
    NgMultiSelectDropDownModule.forRoot(),
  ],
  providers: [
    BarraGovernoService,
    CabecalhoService,
    CertificadoService,
    RodapeService,
    PageService,
    SistemasService,
    AuthService,
    AutenticadoGuard,
    StorageService,
    SolicitacoesService,
    PermissoesService,
    FederalizacaoService,
    CredenciaisService,
    AnexosService,
    ConsultaService,
    ImunizacaoService,
    ApiService,
    HomeRedirectGuard,
    AppInitService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AppInitService],
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorToken,
      multi: true
    },
    { provide: OWL_DATE_TIME_LOCALE, useValue: 'pt-Br' },
    { provide: OwlDateTimeIntl, useClass: DefaultIntl }
  ],
  bootstrap: [AppComponent],
  exports: [
    HomeComponent,
    DetalheComponent,
    PermissoesComponent,
    SolicitacoesComponent,
    SolicitacaoDeAcessoComponent,
    GerenciarCredenciaisComponent,
    DownloadCsvComponent,
    FederalizacaoComponent,
    CpfLiberadoCsvComponent,
    ArquivoCsvComponent,
    BarraGovernoComponent,
    RodapeComponent,
    DetalhePdfComponent,
    AnexosComponent,
    FilterPipe,

  ],
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts